import { Component, Input, inject } from '@angular/core';
import { App } from '@df/core/app';
import { IAddressData } from '@df/session/api/address-book/address';
import { Nexus } from '@tomandco/nexus-api-types';
import find from 'lodash-es/find';
@Component({
    selector: 'address-short',
    template: '<div [innerHTML]="addressString"></div>',
    standalone: true
})
export class AddressShortComponent {
    private app = inject(App);
    /**
     * Default image
     */
    @Input()
    address?: IAddressData;
    get addressString(): string {
        const address = this.address;
        if (address) {
            return [
                address.firstname + ' ' + address.lastname,
                address.street_1,
                address.street_2,
                address.city,
                address.postcode,
                this.getCountryName()
            ]
                .filter(i => !!i)
                .join(', ');
        }
        return '';
    }
    private getCountryName(): string | undefined {
        const countryId = this.address?.country_id;
        if (countryId) {
            return this.getCountryFromAddress(countryId)?.name;
        }
        return undefined;
    }

    private getCountryFromAddress(countryId: string): Nexus.Lib.General.Country | undefined {
        return countryId ? find(this.app.apiConfigService?.countries, country => country.code === countryId) : undefined;
    }
}
